import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    this._escHandler = (event) => { if (event.key === "Escape") this.close() }
  }

  disconnect() {
    document.removeEventListener("keydown", this._escHandler)
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.isOpen = true
    this.backdropTarget.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.panelTarget.classList.add("is-open")
    })
    document.addEventListener("keydown", this._escHandler)
  }

  close() {
    this.isOpen = false
    this.panelTarget.classList.remove("is-open")
    setTimeout(() => this.backdropTarget.classList.add("hidden"), 300)
    document.removeEventListener("keydown", this._escHandler)
  }
}
